export interface NavItem {
  name: string;
  path: string;
  /** Which group this item lives under — undefined for the standalone Dashboard link. Populated for search result context. */
  groupLabel?: string;
}

export interface NavGroup {
  key: string;
  label: string;
  icon: string;
  items: NavItem[];
}

// Standalone, always-visible link — not grouped under a dropdown.
const dashboardLink: NavItem = { name: "Dashboard", path: "/dashboard" };

// Everything else, grouped for the top nav. Same 19 destinations the old flat
// sidebar had — just sorted into named categories instead of one long list.
const navGroups: NavGroup[] = [
  {
    key: "core",
    label: "Core",
    icon: "fa-layer-group",
    items: [
      { name: "Owners", path: "/ownerlisting" },
      { name: "Hosts", path: "/keyhostlisting" },
      { name: "Keys", path: "/keymanagementlisting" },
      { name: "Boxes", path: "/boxmanagementlisting" },
    ],
  },
  {
    key: "requests",
    label: "Requests",
    icon: "fa-inbox",
    items: [
      { name: "Queries", path: "/queriesmanagement" },
      { name: "Host Slot Requests", path: "/hostrequests" },
      { name: "Key Host Requests", path: "/keyhostrequests" },
    ],
  },
  {
    key: "billing",
    label: "Billing",
    icon: "fa-sack-dollar",
    items: [
      { name: "Transactions", path: "/transactionlisting" },
      { name: "Coupons", path: "/coupons" },
      { name: "Subscriptions", path: "/subscriptionmanagement" },
      { name: "Disputes", path: "/disputes" },
      { name: "Host Billing", path: "/hostbilling" },
    ],
  },
  {
    key: "content",
    label: "Content",
    icon: "fa-file-lines",
    items: [
      { name: "Content", path: "/contentmanagement" },
      { name: "Send Notification", path: "/sendnotification" },
      { name: "Reports", path: "/report" },
    ],
  },
  {
    key: "system",
    label: "System",
    icon: "fa-gear",
    items: [
      { name: "Error Logs", path: "/errorlogs" },
      { name: "Capacity Alerts", path: "/capacityalerts" },
      { name: "Cron Jobs", path: "/cronjobs" },
    ],
  },
];

// Flat list of every nav destination, each tagged with its group's label —
// used by the Favourites menu (resolving a saved path back to its name) and
// by nav search (showing "which group is this under" in results).
const allNavItems: NavItem[] = [
  dashboardLink,
  ...navGroups.flatMap((g) => g.items.map((item) => ({ ...item, groupLabel: g.label }))),
];

export { dashboardLink, navGroups, allNavItems };
